export class PowerBiReport {

  public id: string;
  public name: string;
  public embedUrl: string;
  public webUrl: string;

  static fromDto(d: any): PowerBiReport {
    if (!d) {
      return null;
    }

    const report = new PowerBiReport();

    report.id = d.id;
    report.name = d.name;
    report.embedUrl = d.embedUrl;
    report.webUrl = d.webUrl;

    return report;
  }

  static toDto(report: PowerBiReport): any {
    if (!report) {
      return null;
    }

    return {
      id: report.id,
      name: report.name,
      embedUrl: report.embedUrl,
      webUrl: report.webUrl,
    };
  }
}
